import * as BABYLON from "babylonjs";
import { Style } from './styles'

export const createSkyBox = (scene: BABYLON.Scene, style: Style) => {
    const skybox = BABYLON.MeshBuilder.CreateBox("skyBox", {size: 5000.0}, scene);
    const skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
    skyboxMaterial.backFaceCulling = false;
    skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture(`./public/textures/${style.textures}`, scene, ["_px.png","_py.png","_pz.png","_nx.png","_ny.png","_nz.png",]);
    skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
    skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
    skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
    skyboxMaterial.imageProcessingConfiguration = new BABYLON.ImageProcessingConfiguration();
    skyboxMaterial.imageProcessingConfiguration.exposure = style.skyboxExposure;
    skybox.rotation = new BABYLON.Vector3(0, style.skyboxRotation, 0);
    skybox.material = skyboxMaterial;
}
